export default {
    zh: {
        wan26: 'Wan 2.6',
        gptImage15: 'GPT Image 1.5',
        weryAIImage2: 'WeryAI Image 2.0',
        weryAIImage1: 'WeryAI Image 1.0',
        imagePromptInversionTitle: '提示词反推器',
        imagePromptInversionDesc: '上传图片，AI 自动为您生成它的 Prompt',
    },
    en: {
        wan26: 'Wan 2.6',
        gptImage15: 'GPT Image 1.5',
        weryAIImage2: 'WeryAI Image 2.0',
        weryAIImage1: 'WeryAI Image 1.0',
        imagePromptInversionTitle: 'Image Prompt Inversion',
        imagePromptInversionDesc: 'Upload an image, AI automatically generates its Prompt for you',
    },
    ja: {
        wan26: 'Wan 2.6',
        gptImage15: 'GPT Image 1.5',
        weryAIImage2: 'WeryAI Image 2.0',
        weryAIImage1: 'WeryAI Image 1.0',
        imagePromptInversionTitle: 'イメージプロンプト反転',
        imagePromptInversionDesc: '画像をアップロードすると、AIが自動的にプロンプトを生成します',
    },
    ko: {
        wan26: 'Wan 2.6',
        gptImage15: 'GPT Image 1.5',
        weryAIImage2: 'WeryAI Image 2.0',
        weryAIImage1: 'WeryAI Image 1.0',
        imagePromptInversionTitle: '이미지 프롬프트 반전',
        imagePromptInversionDesc: '이미지를 업로드하면 AI가 자동으로 프롬프트를 생성해 드립니다',
    },
    es: {
        wan26: 'Wan 2.6',
        gptImage15: 'GPT Image 1.5',
        weryAIImage2: 'WeryAI Image 2.0',
        weryAIImage1: 'WeryAI Image 1.0',
        imagePromptInversionTitle: 'Inversión de Prompt de Imagen',
        imagePromptInversionDesc: 'Sube una imagen, la IA generará automáticamente su Prompt por ti',
    },
    fr: {
        wan26: 'Wan 2.6',
        gptImage15: 'GPT Image 1.5',
        weryAIImage2: 'WeryAI Image 2.0',
        weryAIImage1: 'WeryAI Image 1.0',
        imagePromptInversionTitle: 'Inversion de Prompt d\'Image',
        imagePromptInversionDesc: 'Téléchargez une image, l\'IA générera automatiquement son Prompt pour vous',
    },
    de: {
        wan26: 'Wan 2.6',
        gptImage15: 'GPT Image 1.5',
        weryAIImage2: 'WeryAI Image 2.0',
        weryAIImage1: 'WeryAI Image 1.0',
        imagePromptInversionTitle: 'Bild-Prompt-Inversion',
        imagePromptInversionDesc: 'Laden Sie ein Bild hoch, die KI generiert automatisch den passenden Prompt für Sie',
    },
    ru: {
        wan26: 'Wan 2.6',
        gptImage15: 'GPT Image 1.5',
        weryAIImage2: 'WeryAI Image 2.0',
        weryAIImage1: 'WeryAI Image 1.0',
        imagePromptInversionTitle: 'Инверсия Промпта Изображения',
        imagePromptInversionDesc: 'Загрузите изображение, ИИ автоматически сгенерирует для него Промпт',
    },
    pt: {
        wan26: 'Wan 2.6',
        gptImage15: 'GPT Image 1.5',
        weryAIImage2: 'WeryAI Image 2.0',
        weryAIImage1: 'WeryAI Image 1.0',
        imagePromptInversionTitle: 'Inversão de Prompt de Imagem',
        imagePromptInversionDesc: 'Carregue uma imagem, a IA gerará automaticamente o Prompt para você',
    },
    it: {
        wan26: 'Wan 2.6',
        gptImage15: 'GPT Image 1.5',
        weryAIImage2: 'WeryAI Image 2.0',
        weryAIImage1: 'WeryAI Image 1.0',
        imagePromptInversionTitle: 'Inversione del Prompt dell\'Immagine',
        imagePromptInversionDesc: 'Carica un\'immagine, l\'IA genererà automaticamente il relativo Prompt per te',
    },
    ar: {
        wan26: 'Wan 2.6',
        gptImage15: 'GPT Image 1.5',
        weryAIImage2: 'WeryAI Image 2.0',
        weryAIImage1: 'WeryAI Image 1.0',
        imagePromptInversionTitle: 'عكس موجه الصورة',
        imagePromptInversionDesc: 'قم بتحميل صورة، وسيقوم الذكاء الاصطناعي بتوليد الموجه (Prompt) الخاص بها تلقائيًا',
    },
    tw: {
        wan26: 'Wan 2.6',
        gptImage15: 'GPT Image 1.5',
        weryAIImage2: 'WeryAI Image 2.0',
        weryAIImage1: 'WeryAI Image 1.0',
        imagePromptInversionTitle: '提示詞反推器',
        imagePromptInversionDesc: '上傳圖片，AI 自動為您生成它的 Prompt',
    },
    pl: {
        wan26: 'Wan 2.6',
        gptImage15: 'GPT Image 1.5',
        weryAIImage2: 'WeryAI Image 2.0',
        weryAIImage1: 'WeryAI Image 1.0',
        imagePromptInversionTitle: 'Odwracanie Promptu Obrazu',
        imagePromptInversionDesc: 'Prześlij obraz, a sztuczna inteligencja automatycznie wygeneruje dla Ciebie prompt',
    },
    th: {
        wan26: 'Wan 2.6',
        gptImage15: 'GPT Image 1.5',
        weryAIImage2: 'WeryAI Image 2.0',
        weryAIImage1: 'WeryAI Image 1.0',
        imagePromptInversionTitle: 'การย้อนกลับพรอมต์รูปภาพ',
        imagePromptInversionDesc: 'อัปโหลดรูปภาพ AI จะสร้างพรอมต์ให้คุณโดยอัตโนมัติ',
    },
    da: {
        wan26: 'Wan 2.6',
        gptImage15: 'GPT Image 1.5',
        weryAIImage2: 'WeryAI Image 2.0',
        weryAIImage1: 'WeryAI Image 1.0',
        imagePromptInversionTitle: 'Billed-Prompt-Inversion',
        imagePromptInversionDesc: 'Upload et billede, AI genererer automatisk prompten for dig',
    },
    no: {
        wan26: 'Wan 2.6',
        gptImage15: 'GPT Image 1.5',
        weryAIImage2: 'WeryAI Image 2.0',
        weryAIImage1: 'WeryAI Image 1.0',
        imagePromptInversionTitle: 'Bilde-Prompt-Inversjon',
        imagePromptInversionDesc: 'Last opp et bilde, AI genererer automatisk prompten for deg',
    },
    nl: {
        wan26: 'Wan 2.6',
        gptImage15: 'GPT Image 1.5',
        weryAIImage2: 'WeryAI Image 2.0',
        weryAIImage1: 'WeryAI Image 1.0',
        imagePromptInversionTitle: 'Beeld-Prompt-Inversie',
        imagePromptInversionDesc: 'Upload een afbeelding, AI genereert automatisch de bijbehorende prompt voor u',
    },
    id: {
        wan26: 'Wan 2.6',
        gptImage15: 'GPT Image 1.5',
        weryAIImage2: 'WeryAI Image 2.0',
        weryAIImage1: 'WeryAI Image 1.0',
        imagePromptInversionTitle: 'Inversi Prompt Gambar',
        imagePromptInversionDesc: 'Unggah gambar, AI secara otomatis menghasilkan prompt-nya untuk Anda',
    },
    tr: {
        wan26: 'Wan 2.6',
        gptImage15: 'GPT Image 1.5',
        weryAIImage2: 'WeryAI Image 2.0',
        weryAIImage1: 'WeryAI Image 1.0',
        imagePromptInversionTitle: 'Görüntü İstemi Tersine Çevirme',
        imagePromptInversionDesc: 'Bir resim yükleyin, yapay zeka sizin için otomatik olarak istemini (Prompt) oluştursun',
    },
}
